module.exports = __webpack_public_path__ + "img/widget_documents.945fed7.svg";